<script>
// Компонент для отображения линейной диаграммы
import { Scatter, mixins } from 'vue-chartjs';

export default {
    extends: Scatter,
    mixins: [mixins.reactiveProp],
    props: ['options'],
    mounted() {
        if (this.chartData !== undefined && Array.isArray(this.chartData)) {
            this.renderChart(this.chartData, this.options);
        }
    }
};
</script>
